import type { FeedEvent } from '@/lib/api/apiTypes';

export function isWebFeedEventHappeningNow(event: FeedEvent) {
  const now = Date.now();
  const startsAt = new Date(event.starts_at).getTime();
  const endsAt = event.ends_at ? new Date(event.ends_at).getTime() : startsAt + 4 * 60 * 60 * 1000;
  return startsAt <= now && now < endsAt;
}

